import axios from 'axios';

export default async function globalSearch(request) {
  let results = null;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/global/search/result`, request)
    .then((response) => {
      if (response.data) {
        results = response.data.data;
      }
    })
    .catch((err) => {
      console.log('api error', err); // eslint-disable-line no-console
    });
  return results;
}
